import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Renders a 1980s IBM PC monochrome CRT terminal background: a subtle
 * phosphor glow vignette plus animated scanlines. Swapped in for
 * BrandHeroBackground while "terminal mode" (the hidden easter egg) is active.
 */
@Component({
  selector: 'app-terminal-hero-background',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="crt-glow" aria-hidden="true"></div>
    <div class="crt-scanlines" aria-hidden="true"></div>
  `,
  styles: [`
    :host {
      display: block;
      position: absolute;
      inset: 0;
      overflow: hidden;
      background: #000000;
    }
    .crt-glow {
      position: absolute;
      inset: 0;
      background: radial-gradient(ellipse at 50% 30%, rgba(51, 255, 102, 0.18) 0%, rgba(0, 0, 0, 0) 70%);
    }
    .crt-scanlines {
      position: absolute;
      inset: 0;
      background: repeating-linear-gradient(
        to bottom,
        rgba(51, 255, 102, 0.06) 0px,
        rgba(51, 255, 102, 0.06) 1px,
        rgba(0, 0, 0, 0) 2px,
        rgba(0, 0, 0, 0) 4px
      );
      animation: scan-drift 8s linear infinite;
      mix-blend-mode: screen;
    }
    @keyframes scan-drift {
      0% { background-position: 0 0; }
      100% { background-position: 0 40px; }
    }
  `]
})
export class TerminalHeroBackground {}
